export default __webpack_public_path__ + "static/media/iphone opt6.605c62cc.gif";